<template>
  <v-dialog persistent width="480" v-model="active">
    <v-card class="ui-module-card rounded-sm" color="primary">
      <v-card-title class="ui-module-titlebar">
        <div class="text-h6">Lista de cargadores</div>
        <v-spacer></v-spacer>
        <v-btn icon color="error" @click="closeDialog"><v-icon>mdi-window-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text>
        <v-virtual-scroll :items="cargadores" item-height="64" height="400" v-if="cargadores.length > 0">
          <template v-slot:default="{ item, index }">
            <v-list-item :key="index">
              <v-list-item-avatar>
                <v-avatar color="secondary" class="white--text">{{ index + 1 }}</v-avatar>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  <div class="text-caption text--secondary">Número económico</div>
                </v-list-item-title>
                <v-list-item-subtitle>
                  <div class="text-body-2">
                    {{ item.noEconomico }}
                  </div>
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn
                  icon
                  :loading="loadingEditarCargador === item.idCargador"
                  @click="openUpdateCargadorDialogComponent(item)"
                  ><v-icon>mdi-pencil</v-icon></v-btn
                >
              </v-list-item-action>
            </v-list-item>
            <v-divider></v-divider>
          </template>
        </v-virtual-scroll>
        <div v-else class="text-subtitle-1">No hay cargadores registrados de este calibre.</div>
      </v-card-text>
    </v-card>
    <update-cargador-dialog-component
      :active="updateCargadorDialog"
      :cargador="selectedCargador"
      @close="updateCargadorDialog = false"
    ></update-cargador-dialog-component>
  </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
import UpdateCargadorDialogComponent from './UpdateCargadorDialogComponent.vue'

export default {
  components: {
    UpdateCargadorDialogComponent,
  },

  props: {
    active: {
      type: Boolean,
    },
  },

  data() {
    return {
      updateCargadorDialog: false,
      selectedCargador: null,
      loadingEditarCargador: false,
    }
  },

  computed: {
    ...mapGetters('cargadores', {
      cargadores: 'getCargadores',
    }),
  },

  methods: {
    closeDialog() {
      this.$emit('close')
    },

    async openUpdateCargadorDialogComponent(cargador) {
      this.loadingEditarCargador = cargador.idCargador
      await this.$nextTick()
      this.loadingEditarCargador = false
      this.selectedCargador = cargador
      this.updateCargadorDialog = true
    },
  },
}
</script>

<style scoped>
.ui-module-card {
  background: rgba(30, 30, 46, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(108, 92, 231, 0.2);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

::v-deep .ui-module-titlebar {
  color: #e0e0e0 !important;
  font-weight: 700 !important;
}
</style>
